import Model, { attr, belongsTo } from '@ember-data/model';
import BulkActionModel from './bulk-action';

export default class JournalCreateModel extends Model {
  @attr('string') name?: string;
  @attr('string') journalTemplateId?: string;
  @attr('date-only') startDate?: Date;
  @attr('date-only') goalDate?: Date;
  @attr('number') mainGoalTypeId?: number; //monthly or annual
  @attr('number') mainGoalAmount?: number;
  @attr('boolean') decisionsRequireGift?: boolean;
  @attr('boolean') createSecondaryOneTimeGoal?: boolean;
  @attr('number') secondaryOneTimeGoalAmount?: number;
  @attr('string') duplicateJournalId?: string;
  @attr('boolean') duplicateMoveUnfinishedTasks?: boolean;
  @attr('date-only') duplicateJournalClosedDate?: Date;
  @attr('string') campaignId?: string;

  // the save response will include a bulk action record if the journal is being duplicated
  @belongsTo('bulk-action', { async: false, inverse: null })
  duplicateJournalBulkAction?: BulkActionModel;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'journal-create': JournalCreateModel;
  }
}
